import SchedulePrintMenu from "@/pages/human-resources/time-management/components/print-menu/SchedulePrintMenu";
import useMonthlySchedulePrintMenuController from "@/pages/human-resources/time-management/schedules/site-schedule/month-view/print-menu/useMonthlySchedulePrintMenuController";
import type { Size } from "@/shared/components/generic/UiEnums";
import type { ReactNode } from "react";

interface Properties {
  size: Size;
}

export default function MonthlySchedulePrintMenu(props: Properties): ReactNode {
  const controller = useMonthlySchedulePrintMenuController();
  return (
    <SchedulePrintMenu
      buttonSize={props.size}
      menuItems={controller.menuItems}
      onItemClicked={controller.runAction}
    />
  );
}
